/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";

const PublicRouter = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={
      (props) => <Component {...props} {...rest} />
    }
  />
);

PublicRouter.defaultProps = {
  location: null,
};

PublicRouter.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.objectOf(PropTypes.any),
};

export default PublicRouter;
